import Route from '@ember/routing/route';
import type RouterService from '@ember/routing/router-service';
import { service } from '@ember/service';
import type Flow from 'garaje/models/flow';
import type Location from 'garaje/models/location';
import type LocationSubscription from 'garaje/models/location-subscription';
import type Subscription from 'garaje/models/subscription';
import type FeatureFlagsService from 'garaje/services/feature-flags';
import type StateService from 'garaje/services/state';

import type { VisitorsInvitesRouteModel } from '../../route';

export interface VisitorsInvitesGroupsIndexRouteModel {
  vrSubscription: Subscription | LocationSubscription | null;
  currentLocation: Location;
  flows: Flow[];
}

export default class VisitorsGroupInvitesIndexRoute extends Route {
  @service declare featureFlags: FeatureFlagsService;
  @service declare router: RouterService;
  @service declare state: StateService;

  get canAccessGroupInvites(): boolean {
    if (!this.featureFlags.isEnabled('visitors-generic-invite-link')) return false;
    return Boolean(this.state.vrSubscription?.canAccessGroupInviteRecords);
  }

  beforeModel(): void {
    if (!this.canAccessGroupInvites) {
      void this.router.replaceWith('visitors.invites.index');
    }
  }

  model(): VisitorsInvitesGroupsIndexRouteModel {
    const { vrSubscription, currentLocation } = this.state;
    const { flows } = this.modelFor('visitors.invites') as VisitorsInvitesRouteModel;

    return { vrSubscription, currentLocation, flows };
  }
}
